"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteProjectFailure = exports.deleteProjectSuccess = exports.deleteProjectRequest = exports.toggleDeleteModal = void 0;
const ActionTypes = require("../../actionTypes/project/delete");
function toggleDeleteModal(project) {
    return {
        type: ActionTypes.TOGGLE_DELETE_MODAL,
        payload: project
    };
}
exports.toggleDeleteModal = toggleDeleteModal;
function deleteProjectRequest(project) {
    return {
        type: ActionTypes.DELETE_PROJECT_REQUEST,
        payload: project
    };
}
exports.deleteProjectRequest = deleteProjectRequest;
function deleteProjectSuccess() {
    return {
        type: ActionTypes.DELETE_PROJECT_SUCCESS
    };
}
exports.deleteProjectSuccess = deleteProjectSuccess;
function deleteProjectFailure(error) {
    return {
        type: ActionTypes.DELETE_PROJECT_FAILURE,
        payload: error
    };
}
exports.deleteProjectFailure = deleteProjectFailure;
//# sourceMappingURL=delete.js.map